export default __webpack_public_path__ + "static/media/geology-uranus.8cec343d.png";